var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container mx-auto bg-gray-200 pb-20"},[_c('div',{staticClass:"px-2 md:px-6 text-lg font-bold mt-10"},[_vm._v(_vm._s(_vm.$t("loggingOut")))])])}
var staticRenderFns = []

export { render, staticRenderFns }